import { DataSource } from '../cms/DataSource';
import { FilterState, listFilterType } from '../../pages/content/listPage/FilterState';
import { ListFilters } from '../../pages/content/listPage/ListFilters';
import { Backend } from '../../api/Backend';
import { ChannelModel } from '../../api/EpgApi.types';
import { GlobalSettingsKeys } from '../../api/models/GlobalSettingsKeys';

export interface FilterInit {
  channel: { text: string; value: ChannelModel };
}

export class EpgListFilterDataSource extends DataSource {
  private _init: FilterInit | undefined;
  private focusPast: boolean;
  private state: FilterState | undefined;
  private filters: listFilterType[];

  constructor(backend: Backend, init = undefined, focusPast = false) {
    super(backend);
    this.filters = [listFilterType.day, listFilterType.channel, listFilterType.tag];
    if (backend.globalSettings.boolValue(GlobalSettingsKeys.showAccessibilityIcons)) {
      this.filters.push(listFilterType.accessibility);
    }
    this._init = init;
    this.focusPast = focusPast;
  }

  override componentDescription() {
    return {
      focusable: true,
      type: ListFilters,
      data: this,
      filterState: this.state,
      backend: this.backend,
    };
  }

  override load(): Promise<EpgListFilterDataSource> {
    return new Promise(resolve => {
      this.state = new FilterState(this._init);
      this.filters.forEach(filter => {
        this.state!.add(filter);
      });
      resolve(this);
    });
  }

  override isEmpty() {
    return false;
  }

  height() {
    return 60;
  }
}
